"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowButton_1 = require("../../atoms/ArrowButton/ArrowButton");
const CrossButton_1 = require("../../atoms/CrossButton/CrossButton");
function NavigationBar({ showBackArrow, onBackClick, onCloseClick, isMobile, isLandscape, }) {
    return ((0, jsx_runtime_1.jsxs)(NavContent, { isMobile: isMobile, isLandscape: isLandscape, "data-e2e": 'NavigationBar_NavContent', children: [showBackArrow ? ((0, jsx_runtime_1.jsx)(StyledArrowButton, { direction: ArrowButton_1.Direction.Left, onClick: onBackClick, isMobile: isMobile, role: "button", tabIndex: 0, "data-e2e": 'NavigationBar_StyledArrowButton' })) : ((0, jsx_runtime_1.jsx)("div", { "data-e2e": 'NavigationBar_div' })), (0, jsx_runtime_1.jsx)(StyledCrossButton, { onClick: onCloseClick, isMobile: isMobile, role: "button", tabIndex: 0, "data-e2e": 'NavigationBar_StyledCrossButton' })] }));
}
exports.NavigationBar = NavigationBar;
const NavContent = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  position: sticky;
  height: 34px;
  color: white;
  padding: 0.25em 1em;
`;
const StyledArrowButton = (0, styled_components_1.default)(ArrowButton_1.ArrowButton) `
  padding-top: 4px;
  color: #b6babc;
  height: 15px;
  width: 15px;

  ${({ isMobile }) => isMobile && `height: 30px; width: 30px;`};
`;
const StyledCrossButton = (0, styled_components_1.default)(CrossButton_1.CrossButton) `
  padding-top: 4px;
  color: #b6babc;
  height: 15px;
  width: 15px;
  max-width: 25px;
  max-height: 25px;
  margin: 0;

  ${({ isMobile }) => isMobile && `height: 25px; width: 25px;`};
`;
